import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CertificateEdit from './view/CertificateEdit';

import './assets/styles/App.scss';

function App() {

  return (
    <BrowserRouter>
      <div className="App fo-gl">
        <Routes>

          <Route
            exact
            path='/6c7a0149d31fb69fd12b831a16dd819daf1655f01af4097e7fe5c23b61586d34/'
            element={ <CertificateEdit /> }
          />

        </Routes>
      </div>
    </BrowserRouter>
  );

}

export default App;
